export const USD_BN_DECIMALS = 6
